import { render, staticRenderFns } from "./estimateVersionFourth.vue?vue&type=template&id=e86dd3e6&scoped=true&"
import script from "./estimateVersionFourth.vue?vue&type=script&lang=js&"
export * from "./estimateVersionFourth.vue?vue&type=script&lang=js&"
import style0 from "./estimateVersionFourth.vue?vue&type=style&index=0&id=e86dd3e6&lang=scss&scoped=true&"
import style1 from "./estimateVersionFourth.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86dd3e6",
  null
  
)

export default component.exports